import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import OTPInput from 'react-otp-input';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import forgotPasswordBanner from '../assets/images/login-banner.gif';
import LandingPageHeader from '../Layouts/LandingPageHeader';
import { forgotPasswordOtpInput, forgotPasswordResendOtp, resetPasswordLinkChecker } from '../Services/Utils/UserApis';
import { notifySet, userSet } from '../Services/Actions/CommonActions';
import { storeUser } from '../Services/config/globals';
import styles from './ForgotPasswordOTPInput.module.css';

function forgotPasswordOTPInput() {
  const params = useParams();
  const [OTP, setOTP] = useState('');
  const [disabled, setDisabled] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    const data = {
      token: params.token
    };
    resetPasswordLinkChecker(data).then((res) => {
      if (res.hasError === false) {
        storeUser(res);
        dispatch(userSet(res));
      } else if (res.hasError === true) {
        navigate('/404');
      }
    });
  }, []);

  const handleChange = (res) => {
    setOTP(res);
    if (res.length === 6) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };
  const handleSubmit = () => {
    const data = {
      otp: OTP,
    };
    forgotPasswordOtpInput(data).then((res) => {
      if (res.status === true) {
        dispatch(notifySet({ type: 'success', message: res.message }));
        navigate('/confirm-password');
      } else if (res.status === -1) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  // resend otp timer

  const [timer, setTimer] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer) {
        setTimer(timer - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  const handleResend = () => {
    forgotPasswordResendOtp().then((res) => {
      if (res.status === true) {
        dispatch(notifySet({ type: 'success', message: res.message }));
        setTimer(60);
        setOTP('');
      } else if (res.status === -1) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div id="fullpage" className="fullpage-wrapper">
      <LandingPageHeader />
      <div className="section">
        <div className="container-fluid banner-top-con full-height-section">
          <div className="container h-100">
            <div className="row h-100">
              <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                <div className="banner-cap-left banner-top banner-top-sm">
                  <img alt="" src={forgotPasswordBanner} />
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                <div className="banner-cap-right caption-block title-bg-text">
                  <h1>
                    <span>FORGOT</span> <br />
                    <span>PASSWORD</span>
                    <br />
                  </h1>
                  <div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="otp">
                            SHARE OTP <span className="validation-icon">*</span>
                          </label>
                          <div className={`${styles['otp-box-list-con']}`}>
                            <OTPInput
                              onChange={handleChange}
                              value={OTP}
                              inputStyle="inputStyle"
                              numInputs={6}
                              separator={<span>&nbsp;</span>}
                              isInputNum="true"
                            />
                          </div>
                          {timer !== 0 ? (
                            <div className="col-12 mt-3 mb-4 text-left">
                              Resend OTP in: <strong> {timer} </strong>
                            </div>
                          ) : (
                            <div className="col-12 mt-3 mb-4 text-left">
                              <span style={{ color: 'red', cursor: 'pointer' }} onClick={handleResend}>Resend OTP</span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <div className="form-group">
                          <div className="btn-con xs-full-btn mt-1">
                            <span className="me-4">
                              <Button
                                className="btn btn-red btn-md"
                                variant="contained"
                                onClick={handleSubmit}
                                disabled={disabled}
                              >
                                Confirm
                              </Button>
                            </span>
                            <span>
                              <Button
                                className="btn btn-red btn-md btn-broder"
                                variant="contained"
                                onClick={() => {
                                  navigate(-1);
                                }}
                              >
                                Back
                              </Button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default forgotPasswordOTPInput;
